import React from 'react'
import {BsFacebook} from 'react-icons/bs'


const HeaderSocials = () => {
  return (
    <div className= 'header__socials'>
        <a href = "https://facebook.com/profile.php?id=100067094586457" target = "_blank" ><BsFacebook/></a>
    </div>
  )
}

export default HeaderSocials